import { isEmpty, startCase } from "lodash";
import WebSkyLayout from "./WebSkyLayout";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../../context/AuthContext";
import { Link, useParams } from "react-router-dom";
import {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import jwt_decode from "jwt-decode";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
import { usePolling } from "../../../component/usePolling";
import SingleEvent from "./SingleEvent";
const HomeSkyWeb = () => {
  let sportsTab = ["cricket", "soccer", "tennis"];
  const { type } = useParams();
  const setSportsTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSportsTab;
  });
  const sportTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.sportTab;
  });
  const tab = useContextSelector(AuthContext, (ctx) => {
    return ctx.tab;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });

  const isFirstRun = useRef(true);
  const [newResult, setNewResult] = useState([]);
  const [activeFav, setActiveFav] = useState([]);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [key, setKey] = useState("Time");
  const [allOdds, setAllOdds] = useState([]);
  const isSportTab = useMemo(() => sportTab, [sportTab]);
  const stableTab = useMemo(() => tab, [tab]);
  const [dataComp, setDataComp] = useState([]);
  const [message, setMessage] = useState([]);
  const messageList = async () => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    hostname = hostname || "sabaexch.com";

    const { status, data: response_users } = await apiGet(
      apiPath.messageList + "?domain=" + hostname
    );
    if (status === 200) {
      if (response_users.success) {
        setMessage(response_users.results);
      }
    }
  };
  useEffect(() => {
    if (!isEmpty(user)) {
      messageList();
    }
  }, [user]);
  useEffect(() => {
    if (isEmpty(type)) {
      setSportsTab("cricket");
    } else {
      setSportsTab(type);
    }
  }, [type]);

  const SortBy = (key, data) => {
    return key == "Matched"
      ? data?.sort((a, b) => b.totalMatched - a.totalMatched)
      : data?.sort(
        (a, b) => new Date(a.eventDateTime) - new Date(b.eventDateTime)
      );
  };
  const filteredArray = (array) => {
    if (array?.length > 0) {
      let check = array?.filter((res) => {
        return res?.seriesName == "Others";
      });
      if (check?.length > 1) {
        let find = check?.find((res) => {
          return res?.seriesName == "Others";
        });
        return [
          ...array?.filter((res) => {
            return res?.seriesName !== "Others";
          }),
          {
            ...find,
            matchList: check
              ?.map((res) => {
                return res?.matchList;
              })
              .flat(),
          },
        ];
      } else {
        return array;
      }
    }
  };
  const getData = async () => {
    setLoader(true);
    setAllOdds([]);
    let { status, data } = await apiGet(apiPath.seriesList, {
      gameType: sportTab,
      userId: !isEmpty(localStorage.getItem("token"))
        ? jwt_decode(localStorage.getItem("token"))?.user?._id
        : "",
    });

    if (data?.success) {
      let newResult = data?.results
        ?.map((res) => {
          return res?.matchList;
        })
        .flat();

      setActiveFav(
        newResult
          ?.filter((res) => {
            return res?.isFavourite;
          })
          ?.map((res) => {
            return res?.eventId;
          })
      );

      setNewResult(
        newResult?.filter((res) => {
          return res?.hasMatchOdds;
        })
      );

      setData(
        filteredArray(data?.results)
          ?.map((res) => {
            return res?.matchList;
          })
          .flat()
          .sort((a, b) => new Date(a.eventDateTime) - new Date(b.eventDateTime))
      );
      setDataComp(filteredArray(data?.results));
    }
    setLoader(false);
  };

  const getOdds = async (id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getMatchOdds +
      `?marketId=${id
        ?.map((res) => {
          return res?.marketId;
        })
        ?.join(",")}&multi=true&eventIds=${id
          ?.map((res) => {
            return res?.eventId;
          })
          ?.join(",")}`
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results?.length > 0) {
          setAllOdds(response_users.results);
        }
      }
    }
  };
  const addToFavioute = async (
    id,
    favoriteType,
    favoriteMarketId,
    eventType
  ) => {
    const { status, data: response_users } = await apiGet(
      apiPath.addToFavourite +
      `?eventId=${id}&favoriteType=${favoriteType}&favoriteMarketId=${favoriteMarketId}&eventType=${eventType}`
    );

    if (response_users?.success) {
      if (activeFav?.includes(id)) {
        setActiveFav((prev) => {
          return prev.filter((item) => {
            return item !== id;
          });
        });
      } else {
        setActiveFav((prev) => {
          return [...prev, id];
        });
      }
    }
  };

  const fetchOdds = useCallback(async () => {
    if (newResult?.length > 0) {
      await getOdds(newResult);
    }
  }, [newResult]);
  usePolling(fetchOdds, 5000, newResult?.length > 0);
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return; // skip initial run if needed
    }
    getData();
  }, [sportTab]);

  return (
    <WebSkyLayout>
      <div id="centerColumn" className="col-center">
        {/* Message */}
        {/* Loading Wrap */}
        {/* <div
          id="loading"
          className="loading-wrap"
          style={{ top: "260px", display: "none" }}
        >
          <ul className="loading">
            <li>
              <img src="https://statics3.e2betms.xyz/images/loading40.gif" />
            </li>
            <li>Loading...</li>
            <br />
            <li>
              <span id="progress" />
            </li>
          </ul>
        </div> */}
        {/* Message */}
        <div id="message" className="message-wrap success">
          <a className="btn-close">Close</a>
          <p />
        </div>
        <div
          id="oneClickLoading"
          className="loading-wrap"
          style={{ display: "none" }}
        >
          <ul className="loading">
            <li>
              <img src="https://statics3.e2betms.xyz/images/loading40.gif" />
            </li>
            <li id="oneClickTime">Place Bets</li>
          </ul>
        </div>
        {/* Game Head */}
        <div id="gameHead" className="game-head" style={{ display: "none" }}>
          {/* Team Table */}
          {/* <a class="favor select">Add Favorite</a> */}
          <a
            id="refreshButton"
            className="refresh"
            style={{ cursor: "pointer" }}
          >
            Refresh
          </a>
          <a
            id="multiMarketPin"
            className="add-pin"
            name="gameHeadPin"
            style={{ cursor: "pointer", display: "none" }}
            title="Add to Multi Markets"
          />
          <table
            id="gameTeam"
            className="game-team"
            style={{ display: "none" }}
          >
            <tbody>
              <tr id="noTeam" style={{ display: "none" }}>
                <td className="game-name">
                  -event name-<span>All Markets</span>
                </td>
              </tr>
              <tr id="twoTeam" style={{ display: "none" }}>
                <td id="gameVisit" className="game-visit">
                  -visit-
                  <span />
                </td>
                <td id="gameVs" className="game-vs">
                  <div>
                    All Markets<span>VS</span>
                  </div>
                </td>
                <td id="gameHome" className="game-home">
                  -home-
                  <span />
                </td>
              </tr>
            </tbody>
          </table>
          <a
            id="lineMarketRulesBtn"
            className="btn-rules"
            style={{ cursor: "pointer", display: "none" }}
          >
            <img src="https://statics3.e2betms.xyz/images/transparent.gif" />
            Rules
          </a>
          <div
            id="lineMarketRulesWrap"
            className="rules-wrap"
            style={{ display: "none" }}
          >
            <h3>Line Market Rules and Information</h3>
            <div className="rules-content">
              <p>
                How many runs would be scored in mentioned overs, If{" "}
                <strong> 'Back/Yes' </strong> bet is made then it will be win
                bet if the runs scored in the mentioned overs are{" "}
                <strong> equal or more </strong> then the Backed Runs otherwise
                it will be a Lost bets. If <strong>'Lay/No' </strong> bet is
                made then it will be a win bet if Runs scored in the mentioned
                overs are <strong> less </strong> than the lay runs otherwise it
                will be lost bet. All the line markets will be settled only if
                the mentioned stipulated overs are completed or if the Batting
                team is bowled out (All out) or the runs are chased, given the
                inning's stipulated(or reduced) overs are more than or equal to
                the stipulated over of that particular line Market.
              </p>
              <p>
                <strong> "Matched Tied" </strong> and{" "}
                <strong> "Completed Match" </strong> doesn't affect the settling
                of Line markets.
              </p>
            </div>
            <ul className="btn-wrap break">
              <li>
                <a
                  id="lineMarketRulesOk"
                  className="btn"
                  style={{ cursor: "pointer" }}
                >
                  OK
                </a>
              </li>
            </ul>
          </div>
          <table
            id="cricketScoreBoard"
            className="game-scores"
            style={{ display: "none" }}
          >
            <tbody>
              <tr>
                <td id="gameHeadPinSpace" className="scores-space" />
                <td className="scores-team">
                  <h4 id="teamHome">HOME</h4>
                  <h4 id="teamAway">AWAY</h4>
                  <ul className="scores-time">
                    <li id="description" className="filter-first" />
                    <li id="currentDay" />
                  </ul>
                </td>
                <td
                  id="inningsBox1"
                  className="scores-box"
                  style={{ display: "none" }}
                >
                  <h4 id="runsHome">
                    <span />
                  </h4>
                  <h4 id="runsAway">
                    <span />
                  </h4>
                  <span id="inningsIndex" className="scores-inns">
                    Innings 1
                  </span>
                </td>
                <td
                  id="inningsBoxTemplate"
                  className="scores-box"
                  style={{ display: "none" }}
                >
                  <h4 id="runsHome">
                    <span />
                  </h4>
                  <h4 id="runsAway">
                    <span />
                  </h4>
                  <span id="inningsIndex" className="scores-inns" />
                </td>
                <td className="scores-space" />
              </tr>
            </tbody>
          </table>
          <table
            id="tennisScoreBoard"
            className="game-scores tennis"
            style={{ display: "none" }}
          >
            <tbody>
              <tr>
                <td id="gameHeadPinSpace" className="scores-space" />
                <td className="scores-team">
                  <h4 id="teamHome">
                    ${"{"} Home {"}"}
                  </h4>
                  <h4 id="teamAway">
                    ${"{"} Away {"}"}
                  </h4>
                  <ul className="scores-time">
                    <li id="currentSet" className="filter-first" />
                    <li id="fullTimeElapsed" />
                    <li>
                      <span id="court" />
                    </li>
                  </ul>
                </td>
                <td id="setBox1" className="scores-box">
                  <h4 id="setHome" />
                  <h4 id="setAway" />
                  <span className="scores-inns">1</span>
                </td>
                <td id="setBox2" className="scores-box">
                  <h4 id="setHome" />
                  <h4 id="setAway" />
                  <span className="scores-inns">2</span>
                </td>
                <td id="setBox3" className="scores-box last-box">
                  <h4 id="setHome" />
                  <h4 id="setAway" />
                  <span className="scores-inns">3</span>
                </td>
                <td id="points" className="scores-box last-box">
                  <h4 id="pointsHome" className="scores-now">
                    0
                  </h4>
                  <h4 id="pointsAway" className="scores-now">
                    0
                  </h4>
                  <span className="scores-inns">Points</span>
                </td>
                <td id="aces" className="scores-box scores-other">
                  <h4 id="acesHome">0</h4>
                  <h4 id="acesAway">0</h4>
                  <span className="scores-inns">Aces</span>
                </td>
                <td id="faults" className="scores-box scores-other">
                  <h4 id="faultsHome">0</h4>
                  <h4 id="faultsAway">0</h4>
                  <span className="scores-inns">Faults</span>
                </td>
                <td id="breaks" className="scores-box scores-other last-box">
                  <h4 id="breaksHome">0</h4>
                  <h4 id="breaksAway">0</h4>
                  <span className="scores-inns">Breaks</span>
                </td>
                <td className="scores-space" />
                <td
                  id="setBoxTemplate"
                  className="scores-box last-box"
                  style={{ display: "none" }}
                >
                  <h4 id="setHome" />
                  <h4 id="setAway" />
                  <span id="setIndex" className="scores-inns" />
                </td>
                <td className="scores-space" />
              </tr>
            </tbody>
          </table>
          <div
            id="soccerScoreBoard"
            className="game-scores"
            style={{ display: "none" }}
          >
            <ul>
              <li className="game-visit">
                <h4 id="teamHome" />
              </li>
              <li className="scores-box">
                <p id="vsScores" className="scores-now" />
                <span id="timeElapsed" className="scores-now" />
              </li>
              <li className="game-home">
                <h4 id="teamAway" />
              </li>
            </ul>
            <div className="game-progress">
              <div className="progress-bar">
                <div
                  id="progressPercent"
                  className="progress-now"
                  style={{ width: "0%" }}
                />
                <img
                  id="soccerEventTemplate"
                  className
                  style={{ left: "0%", display: "none" }}
                  src="https://statics3.e2betms.xyz/images/transparent.gif"
                />
                <div
                  id="popupTemplate"
                  className="score-pop"
                  style={{ left: "0%", display: "none" }}
                >
                  <ul>
                    <li id="matchTime" className="scores-now" />
                    <li>
                      <img
                        className
                        src="https://statics3.e2betms.xyz/images/transparent.gif"
                      />
                    </li>
                  </ul>
                </div>
                <span
                  id="sumTemplate"
                  className="sum-status"
                  style={{ left: "0%", display: "none" }}
                />
                <div
                  id="sumPopupTemplate"
                  className="score-pop-last"
                  style={{ left: "0%", display: "none" }}
                >
                  <ul id="list">
                    <li
                      id="matchTimeTemplate"
                      className="scores-now"
                      style={{ display: "none" }}
                    />
                    <li id="iconTemplate" style={{ display: "none" }}>
                      <img
                        className
                        src="https://statics3.e2betms.xyz/images/transparent.gif"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="marquee-box" style={{ display: "flex" }}>
          <h4>News</h4>
          <div className="marquee">
            <div className="js-marquee-wrapper">
              <marquee scrollamount={3} class="js-marquee">
                <a>
                  <span>14 Nov 2025</span>Event :- India v South Africa : Market
                  :- 22 Over SA ''Whole Market Voided Because Wrong Rate Offered
                  By Mistake .. ... Sorry for the Inconvenience Caused
                </a>
              </marquee>
            </div>
          </div>
        </div>
        <div id="overWrap" className="over-wrap" style={{}}>
          <div className="kv-wrap" style={{}}>
            <a>
              <img src="/assets/images/KV.jpg" alt />
            </a>
          </div>

          <div
            id="gameHighlightWrap"
            className="game-highlight-wrap col3"
            style={{}}
          >
            <h3>
              Sports Highlights
              <div className="highlight-sorting">
                <label htmlFor="lang">View by</label>
                <div className="select">
                  <select
                    id="viewType"
                    name="View"
                    value={key}
                    onChange={(e) => setKey(e.target.value)}
                  >
                    <option
                      id="competitionName"
                      value="Competition"
                      orderby="asc"
                      priority="asc"
                    >
                      Competition
                    </option>
                    <option
                      id="openDateTime"
                      value="Time"
                      orderby="asc"
                      inplay="desc"
                    >
                      Time
                    </option>
                    <option id="totalMatched" value="Matched" orderby="desc">
                      Matched
                    </option>
                  </select>
                </div>
              </div>
            </h3>
            {isEmpty(type) && (
              <ul id="highlightLabel" className="tab-highlight">
                {sportsTab?.map((res) => {
                  return (
                    <li>
                      <Link
                        // to={`/sports-sky/${res}`}
                        id="highlightTab4"
                        style={{ cursor: "pointer" }}
                        onClick={() => setSportsTab(res)}
                        className={sportTab == res ? "select" : ""}
                      >
                        {startCase(res)}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            )}
            <ul className="slip-head">
              <li className="col-game" />
              <li className="col-matched">Matched</li>
              <li className="col-visit">1</li>
              <li className="col-draw">x</li>
              <li className="col-home">2</li>
              <li className="col-info" />
            </ul>
            <div className="game-list">
              {data?.length == 0 && (
                <div id="noDataDiv" className="no-data">
                  <p>There are no events to be displayed.</p>
                </div>
              )}
              {["Time", "Matched"].includes(key) && data?.length > 0 && (
                <div id="eventBoard">
                  {SortBy(key, data)?.map((res) => {
                    let matchOdds =
                      allOdds?.find((item) => {
                        return item?.mi == res?.marketId;
                      }) || {};

                    return (
                      <SingleEvent
                        matchOdds={matchOdds}
                        res={res}
                        addToFavioute={addToFavioute}
                      />
                    );
                  })}
                </div>
              )}

              {key == "Competition" && dataComp?.length > 0 && (
                <div id="eventBoard">
                  {dataComp?.map((item) => {
                    return (
                      <Fragment>
                        <h3
                          id="CSAWomensPro50"
                          className="leagueTitle competition-expand"
                          priority={1}
                        >
                          <a>{item?.seriesName}</a>
                        </h3>
                        {item?.matchList?.map((res) => {
                          let matchOdds =
                            allOdds?.find((obj) => {
                              return obj?.mi == res?.marketId;
                            }) || {};

                          return (
                            <SingleEvent
                              matchOdds={matchOdds}
                              res={res}
                              addToFavioute={addToFavioute}
                            />
                          );
                        })}
                      </Fragment>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          <div className="footer">
            {/* Browser Support */}
            <div className="browser-wrap">
              <img src="https://statics3.e2betms.xyz/images/transparent.gif" />
              <br />
              Our website works best in the newest and last prior version of
              these browsers: <br />
              Google Chrome. Firefox
            </div>
          </div>
        </div>

      </div>
    </WebSkyLayout>
  );
};

export default HomeSkyWeb;
